/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ArchiveIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "archive", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M4.5 7.5H20.5M4.5 7.5V20.5H20.5V7.5M4.5 7.5L6.5 4.5H18.5L20.5 7.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 17.5L16 14M12.5 17.5L9 14M12.5 17.5V10.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ArchiveIcon);
export default ForwardRef;
//# sourceMappingURL=archiveIcon.js.map